(() => {
  const config = document.getElementById('FrSearchRoutes');
  if (!config) return;
  let data;
  try { data = JSON.parse(config.textContent); } catch { return; }
  const normalize = value => value.toLocaleLowerCase('sv').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const routes = data.routes.map(route => ({ ...route, terms: [route.title, ...route.aliases].map(normalize) }));
  const exact = value => routes.find(route => route.terms.includes(normalize(value)));
  const formInput = form => form?.querySelector('input[name="q"]');
  const suggestion = form => {
    let box = form.querySelector('.fr-search-suggest');
    if (box) return box;
    box = document.createElement('div');
    box.className = 'fr-search-suggest';
    box.hidden = true;
    box.setAttribute('aria-label', data.labels.categories);
    form.style.position = 'relative';
    form.append(box);
    return box;
  };
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('form[role="search"] input[name="q"]')) return;
    const form = input.closest('form');
    const term = normalize(input.value);
    const box = suggestion(form);
    box.replaceChildren();
    if (term.length < 2) { box.hidden = true; return; }
    const matches = routes.filter(route => route.terms.some(value => value.startsWith(term))).slice(0, 4);
    matches.forEach(route => {
      const link = document.createElement('a');
      link.href = route.url;
      link.textContent = `${route.title} · ${route.count} ${data.labels.products}`;
      box.append(link);
    });
    box.hidden = matches.length === 0;
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[role="search"]');
    const input = formInput(form);
    if (!input) return;
    const route = exact(input.value);
    if (!route) return;
    const target = new URL(route.url, location.origin);
    if (target.origin !== location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(target.href);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-fr-tag-filter] a');
    if (link && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
      const target = new URL(link.href, location.origin);
      const current = new URL(location.href);
      current.searchParams.forEach((value, key) => {
        if (key.startsWith('filter.') || key === 'sort_by') target.searchParams.append(key, value);
      });
      link.href = target.href;
    }
    document.querySelectorAll('.fr-search-suggest').forEach(box => {
      if (!box.closest('form').contains(event.target)) box.hidden = true;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.fr-search-suggest').forEach(box => { box.hidden = true; });
  });
  const header = document.querySelector('.template-search__header');
  const input = header?.querySelector('input[name="q"]');
  const route = input && exact(input.value);
  if (route) {
    const box = document.createElement('div');
    box.className = 'fr-search-route';
    const text = document.createElement('p');
    text.textContent = data.labels.precise;
    const link = document.createElement('a');
    link.href = route.url;
    link.textContent = `${route.title} · ${route.count} ${data.labels.products} →`;
    box.append(text, link);
    header.append(box);
  }
})();
